import React, { useContext } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { AuthContext, UserContext } from "./authProvider/main";

export const MasterRoute = ({ children, ...rest }: any) => {
    const authContext = useContext(AuthContext);
    const userContext: any = useContext(UserContext);
    const isMaster = userContext.data?.user_id === 10;

    return (
        <Route
            render={({ location }) => {
                if (!isMaster) {
                    return (
                        <Redirect
                            to={{
                                pathname: authContext.isAuthenticated ? "/dashboard" : "/login",
                                state: { from: location },
                            }}
                        />
                    );
                }

                return <Switch>{children}</Switch>;
            }}
        />
    );
};
